import { createFileRoute } from "@tanstack/react-router";
import { LandingNav } from "@/components/landing/landing-nav";
import { LandingHero } from "@/components/landing/landing-hero";
import { LandingStats } from "@/components/landing/landing-stats";
import { LandingPainPoints } from "@/components/landing/landing-painpoints";
import { LandingFeatures } from "@/components/landing/landing-features";
import { LandingPortals } from "@/components/landing/landing-portals";
import { LandingTestimonials } from "@/components/landing/landing-testimonials";
import { LandingPricing } from "@/components/landing/landing-pricing";
import { LandingSteps } from "@/components/landing/landing-steps";
import { LandingFAQ } from "@/components/landing/landing-faq";
import { LandingCTA } from "@/components/landing/landing-cta";
import { LandingFooter } from "@/components/landing/landing-footer";

export const Route = createFileRoute("/")({
  head: () => ({
    meta: [
      { title: "Ezyclass — Phần mềm quản lý trung tâm học tập" },
      {
        name: "description",
        content:
          "Ezyclass — Phần mềm quản lý trung tâm dành cho người Việt. Điểm danh 1 click, giao bài tự động, báo cáo cho phụ huynh. Dùng thử miễn phí.",
      },
      { property: "og:title", content: "Ezyclass — Phần mềm quản lý trung tâm học tập" },
      {
        property: "og:description",
        content:
          "Điểm danh 1 click, giao bài tự động, báo cáo cho phụ huynh. Giải pháp toàn diện cho trung tâm, lớp học tại Việt Nam.",
      },
      { property: "og:url", content: "https://ezyclass.com/" },
      { property: "og:type", content: "website" },
    ],
    links: [{ rel: "canonical", href: "https://ezyclass.com/" }],
    scripts: [
      {
        type: "application/ld+json",
        children: JSON.stringify({
          "@context": "https://schema.org",
          "@type": "SoftwareApplication",
          name: "Ezyclass",
          applicationCategory: "BusinessApplication",
          operatingSystem: "Web",
          url: "https://ezyclass.com/",
          description:
            "Phần mềm quản lý trung tâm học tập dành cho Việt Nam. Điểm danh 1 click, giao bài, báo cáo tự động.",
          offers: { "@type": "Offer", price: "0", priceCurrency: "VND" },
        }),
      },
      {
        type: "application/ld+json",
        children: JSON.stringify({
          "@context": "https://schema.org",
          "@type": "FAQPage",
          mainEntity: [
            { q: "Đây là bản demo hay sản phẩm thật?", a: "Hiện tại đây là bản demo để bạn trải nghiệm giao diện và luồng làm việc của ba vai trò. Dữ liệu chỉ lưu trên trình duyệt của bạn." },
            { q: "Tôi có cần đăng ký tài khoản không?", a: "Không. Bạn có thể chọn nhanh một vai trò để vào thử mà không cần email hay mật khẩu." },
            { q: "Dữ liệu của tôi được lưu ở đâu?", a: "Trong môi trường demo, dữ liệu được lưu cục bộ trên trình duyệt. Khi xoá cache trình duyệt, dữ liệu sẽ mất." },
            { q: "Có hỗ trợ nhiều trung tâm cùng lúc không?", a: "Bản hiện tại tập trung cho một trung tâm. Phiên bản đầy đủ sẽ hỗ trợ nhiều cơ sở và phân quyền theo cơ sở." },
            { q: "Tôi muốn dùng cho trung tâm thật thì sao?", a: "Bạn có thể liên hệ qua email ở phần chân trang. Chúng tôi sẽ hỗ trợ tư vấn và triển khai cho trung tâm của bạn." },
          ].map((f) => ({
            "@type": "Question",
            name: f.q,
            acceptedAnswer: { "@type": "Answer", text: f.a },
          })),
        }),
      },
    ],
  }),
  component: Landing,
});

function Landing() {
  return (
    <div className="min-h-screen bg-white dark:bg-slate-950 text-slate-900 dark:text-white transition-colors duration-300">
      <LandingNav />
      <LandingHero />
      <LandingStats />
      <LandingPainPoints />
      <LandingFeatures />
      <LandingPortals />
      <LandingTestimonials />
      <LandingPricing />
      <LandingSteps />
      <LandingFAQ />
      <LandingCTA />
      <LandingFooter />
    </div>
  );
}
